import type { BaseProvider } from '../sdk/BaseProvider';
import { EventimFanSaleProvider } from './EventimFanSaleProvider';
import { SeatGeekProvider } from './SeatGeekProvider';
import { StubHubProvider } from './StubHubProvider';
import { TicketmasterConnectorDefinition } from './TicketmasterProvider';
import { TicketSwapProvider } from './TicketSwapProvider';
import { ViagogoConnectorDefinition } from './ViagogoProvider';
export const providerConnectors: readonly BaseProvider[] = [new TicketmasterConnectorDefinition(), new ViagogoConnectorDefinition(), new StubHubProvider(), new SeatGeekProvider(), new TicketSwapProvider(), new EventimFanSaleProvider()];
